import React from 'react';
import { Form } from '~/components';
import SettingsFormSection from '../../SettingsFormSection';
import SlackChannelSelect from '../SlackChannelSelect';

export default function Slack() {
  return (
    <SettingsFormSection title="Slack">
      <Form.Control help="Assign a project channel to get project updates in Slack.">
        <SlackChannelSelect name="slackChannelId" />
      </Form.Control>
    </SettingsFormSection>
  );
}
